import functionCall from './function-call.js';
import hasOwnProperty_1 from './has-own-property.js';
import objectIsPrototypeOf from './object-is-prototype-of.js';
import regexpFlags from './regexp-flags.js';

var call = functionCall;
var hasOwn = hasOwnProperty_1;
var isPrototypeOf = objectIsPrototypeOf;
var regExpFlags = regexpFlags;

var RegExpPrototype = RegExp.prototype;

var regexpGetFlags = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype) && !hasOwn(R, 'flags') && isPrototypeOf(RegExpPrototype, R)
    ? call(regExpFlags, R) : flags;
};

export { regexpGetFlags as default };
